import { cx } from '@mage-ui/styled-system/css';
import {
  bordersWrapper,
  containerWrapper,
  focus,
  footer,
  gridCol,
  logoConsorci,
  logoStore,
  text,
} from '@mage-ui/styled-system/recipes';
import Link from 'next/link';
import { LogoEoiFooter } from '../../data-display/logos/LogoEoiFooter';
import { LogoImage } from '../../data-display/logos/LogoImage';
import { LogoWrapper } from '../../data-display/logos/LogoWrapper';
import { GridCol } from '../grids/GridCol';
import { GridRow } from '../grids/GridRow';
import { FooterMenu } from './FooterMenu';
import { FooterPolicy } from './FooterPolicy';

export const Footer = ({
  logoData,
  menuData,
  policyData,
  contactData,
  logoAppData,
  logoMenuData,
  texts,
  ...props
}) => {
  return (
    <footer className={footer().root} {...props}>
      <div className={containerWrapper()}>
        <GridRow className={cx(footer().contentWrapper)}>
          <div className={footer().contactGrid}>
            <GridCol className={gridCol({ colSpanL: '3' })}>
              <LogoEoiFooter logoData={logoData} />
            </GridCol>

            <GridCol className={gridCol({ colSpanM: '6', colSpanL: '2' })}>
              <div className={footer().content}>
                <p
                  className={cx(
                    footer().title,
                    text({ size: '3', weight: 'bold' }),
                  )}
                >
                  {texts.ubication}
                </p>

                <address>
                  <ul>
                    {contactData?.street && (
                      <li>
                        <span className={text({ size: '3', weight: 'medium' })}>
                          {contactData?.street}
                        </span>
                      </li>
                    )}
                    {contactData?.city && (
                      <li>
                        <span className={text({ size: '3', weight: 'medium' })}>
                          {contactData?.city}
                        </span>
                      </li>
                    )}
                  </ul>
                </address>
              </div>
            </GridCol>

            <GridCol
              className={gridCol({
                colSpanM: '6',
                colSpanL: '3',
              })}
            >
              <div className={footer().content}>
                <p
                  className={cx(
                    footer().title,
                    text({ size: '3', weight: 'bold' }),
                  )}
                >
                  {texts.contact}
                </p>

                <ul>
                  {contactData?.tel && (
                    <li>
                      <Link
                        href={`tel:${contactData?.tel}`}
                        className={cx(
                          footer().link,
                          text({ size: '3', weight: 'medium' }),
                          focus(),
                        )}
                      >
                        {texts.tel} {contactData?.tel}
                      </Link>
                    </li>
                  )}
                  {contactData?.mail &&
                    contactData?.mail !== 'footer.email' && (
                      <li>
                        <Link
                          href={`mailto:${contactData?.mail}`}
                          className={cx(
                            footer().link,
                            text({ size: '3', weight: 'medium' }),
                            focus(),
                          )}
                        >
                          {contactData?.mail}
                        </Link>
                      </li>
                    )}
                  {contactData?.contactWeb &&
                    contactData?.contactWeb !== 'footer.contactWeb' && (
                      <li>
                        <Link
                          href={`${contactData?.contactWeb}`}
                          className={cx(
                            footer().link,
                            text({ size: '3', weight: 'medium' }),
                            focus(),
                          )}
                        >
                          {contactData?.contactWebTitle}
                        </Link>
                      </li>
                    )}
                </ul>
              </div>
            </GridCol>
          </div>

          <div className={footer().actionGrid}>
            <GridCol
              className={cx(
                gridCol({ colSpanL: '3', colStartL: '9' }),
                footer().gridLogoDownload,
              )}
            >
              <div className={footer().content}>
                <p
                  className={cx(
                    footer().title,
                    text({ size: '3', weight: 'bold' }),
                    footer().titleApp,
                  )}
                >
                  {texts.download}
                </p>
                <ul
                  className={footer().logoWrapper}
                  aria-label={texts.downloadList}
                >
                  {logoAppData?.map((item) => (
                    <li key={item?.meta?.key}>
                      <LogoWrapper
                        logoData={item}
                        className={cx(
                          item.className,
                          footer().linkImg,
                          logoStore(),
                        )}
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        <LogoImage data={item} />
                      </LogoWrapper>
                    </li>
                  ))}
                </ul>
              </div>
            </GridCol>

            <GridCol
              className={cx(
                gridCol({ colSpanL: '6' }),
                bordersWrapper({ color: 'inverted' }),
              )}
            >
              <FooterMenu data={menuData} texts={texts} />
            </GridCol>

            <GridCol
              className={cx(
                gridCol({ colSpanL: '5' }),
                bordersWrapper({ color: 'inverted' }),
                footer().gridLogoMenu,
              )}
            >
              {logoMenuData?.map((item) => (
                <LogoWrapper
                  key={item?.meta?.key}
                  logoData={item}
                  className={cx(
                    item.className,
                    footer().linkImg,
                    logoConsorci(),
                  )}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <LogoImage data={item} />
                </LogoWrapper>
              ))}
            </GridCol>
          </div>

          <GridCol className={gridCol({ colSpanL: '11' })}>
            <FooterPolicy data={policyData} texts={texts} />
          </GridCol>
        </GridRow>
      </div>
    </footer>
  );
};
